import { highlightText } from '~/shared/lib/highlight-text'
import { Text } from '~/shared/ui'
import type { DataExtractionEventProps } from '../../model'
import { EventNotes, FieldsGrid } from '../shared'

export function DataExtractionEvent({
  event,
  searchQuery,
}: {
  event: DataExtractionEventProps
  searchQuery: string
}) {
  return (
    <>
      <div className="flex flex-col gap-0.5 py-[3px]">
        <Text appearance="SUBTITLE2">{highlightText(event.title, searchQuery)}</Text>
        {event.fields ? (
          <FieldsGrid
            fields={event.fields}
            searchQuery={searchQuery}
            userRole={event.userRole}
          />
        ) : null}
      </div>
      {event.notes && event.userRole === 'person' && (
        <EventNotes
          notes={event.notes}
          searchQuery={searchQuery}
        />
      )}
    </>
  )
}
